import { api } from './client';

export function listInvites() {
  return api.get('/invites');
}

export function createInviteLink() {
  return api.post('/invites/link', {});
}

export function sendInvite(email) {
  return api.post('/invites/email', { email });
}
